// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type SettingsSvgrepoComsvgIconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function SettingsSvgrepoComsvgIcon(
  props: SettingsSvgrepoComsvgIconProps
) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      version={"1.1"}
      x={"0"}
      y={"0"}
      viewBox={"0 0 458.12 458.12"}
      xmlSpace={"preserve"}
      height={"1em"}
      width={"1em"}
      style={{
        fill: "currentcolor",

        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M229.063 106.991c-67.305 0-122.062 54.756-122.062 122.061s54.757 122.062 122.062 122.062 122.062-54.756 122.062-122.062c-.001-67.305-54.758-122.061-122.062-122.061zm0 224.123c-56.277 0-102.062-45.785-102.062-102.062s45.784-102.061 102.062-102.061 102.062 45.784 102.062 102.061-45.785 102.062-102.062 102.062z"
        }
      ></path>

      <path
        d={
          "M229.063 175.963c-29.273 0-53.089 23.815-53.089 53.089s23.815 53.089 53.089 53.089 53.089-23.816 53.089-53.089-23.816-53.089-53.089-53.089zm0 76.178c-12.731 0-23.089-10.358-23.089-23.089s10.357-23.089 23.089-23.089 23.089 10.357 23.089 23.089-10.358 23.089-23.089 23.089z"
        }
      ></path>

      <path
        d={
          "M454.321 187.337a15 15 0 00-14.751-12.281h-25.108a191.225 191.225 0 00-16.131-38.915l17.77-17.77a15 15 0 001.74-19.125 231.62 231.62 0 00-26.808-32.162 230.691 230.691 0 00-32.185-26.814 15 15 0 00-19.115 1.747l-17.769 17.769a191.455 191.455 0 00-38.909-16.136V18.531c0-7.24-5.171-13.447-12.292-14.753-27.411-5.03-56.096-5.023-83.417.012a15 15 0 00-12.281 14.751V43.65a191.45 191.45 0 00-38.909 16.136l-17.77-17.769a15 15 0 00-19.115-1.747 230.807 230.807 0 00-32.185 26.814 231.546 231.546 0 00-26.808 32.163 15.002 15.002 0 001.741 19.124l17.773 17.774a191.294 191.294 0 00-16.128 38.911H18.55a15.001 15.001 0 00-14.752 12.282A230.833 230.833 0 000 229.056a231.67 231.67 0 003.786 41.697 15 15 0 0014.754 12.293h25.126a191.294 191.294 0 0016.128 38.911l-17.767 17.767a15 15 0 00-1.747 19.115 230.788 230.788 0 0026.813 32.185 231.607 231.607 0 0032.162 26.808 15 15 0 0019.124-1.74l17.776-17.776a191.468 191.468 0 0038.909 16.137v25.109c0 7.236 5.165 13.44 12.281 14.751a230.704 230.704 0 0041.719 3.798c13.979 0 28.007-1.274 41.698-3.787a15 15 0 0012.292-14.753v-25.12a191.417 191.417 0 0038.909-16.136l17.775 17.775a14.999 14.999 0 0019.124 1.741 231.6 231.6 0 0032.162-26.807 230.76 230.76 0 0026.814-32.185 15 15 0 00-1.747-19.115l-17.763-17.763a191.225 191.225 0 0016.131-38.915h25.118c7.24 0 13.446-5.171 14.754-12.292a231.599 231.599 0 003.786-41.698 230.392 230.392 0 00-3.796-41.719zm-27.633 65.709h-23.854a15 15 0 00-14.639 11.729 161.695 161.695 0 01-21.358 51.529 15 15 0 002.058 18.646l16.875 16.876a201.393 201.393 0 01-33.932 33.936l-16.884-16.883a14.999 14.999 0 00-18.645-2.058c-14.822 9.408-30.932 16.308-47.887 20.508-1.208.3-2.428.573-3.646.846a15 15 0 00-11.72 14.637v23.867a202.047 202.047 0 01-47.99-.003v-23.865a15.001 15.001 0 00-11.727-14.639 156.784 156.784 0 01-3.649-.846c-16.947-4.199-33.056-11.098-47.877-20.506a15.003 15.003 0 00-18.645 2.057l-16.885 16.884a201.467 201.467 0 01-33.932-33.936l16.88-16.88a15 15 0 002.058-18.645 161.71 161.71 0 01-21.355-51.527 15 15 0 00-14.639-11.728H31.433a201.312 201.312 0 01.003-47.989h23.859a15.002 15.002 0 0014.639-11.728 161.733 161.733 0 0121.355-51.527 14.998 14.998 0 00-2.058-18.645L72.35 106.274a201.635 201.635 0 0133.935-33.932l16.883 16.882a15 15 0 0018.645 2.057c14.821-9.408 30.93-16.307 47.882-20.507 1.208-.3 2.426-.572 3.645-.845a15.001 15.001 0 0011.727-14.639V31.427a202.1 202.1 0 0147.99-.003v23.867a15 15 0 0011.72 14.637c1.219.273 2.438.546 3.654.848 16.947 4.199 33.056 11.098 47.879 20.506a14.998 14.998 0 0018.645-2.058l16.882-16.881a201.224 201.224 0 0117.985 15.955 202.044 202.044 0 0115.951 17.977l-16.878 16.878a15.001 15.001 0 00-2.058 18.646 161.673 161.673 0 0121.358 51.529 15 15 0 0014.639 11.729h23.852a201.471 201.471 0 011.436 24 202.38 202.38 0 01-1.434 23.989z"
        }
      ></path>
    </svg>
  );
}

export default SettingsSvgrepoComsvgIcon;
/* prettier-ignore-end */
